/** Same project key as the existing <uc-config> elements. */
export const UPLOADCARE_PUBKEY = '52ceebe300b5bee7b70f';

/** Matches the gallery uploaders' accept list. */
export const STORY_MEDIA_ACCEPT =
  'video/*,image/png,image/jpeg,image/jpg,image/webp,image/gif,image/heic,image/heif,image/bmp,image/tiff,image/avif';

export const PHONE_UPLOAD_POLL_MS = 2500;

/** Files one code accepts on the gallery step; the phone can keep tapping "Add more" until then. */
export const PHONE_UPLOAD_MAX_FILES = 10;

export type PhoneUploadSessionStatus = 'open' | 'complete' | 'expired' | 'cancelled';

/** What the desktop asks for when it opens a code. */
export interface PhoneUploadContext {
  companyId: number;
  /** 0 or missing while a guest story has no draft yet. */
  storyId?: number;
  /** Which uploader asked, e.g. "story-gallery"; stored for support and analytics. */
  context: string;
  maxFiles: number;
  accept: string;
}

export interface PhoneUploadFile {
  uuid: string;
  cdn_url: string;
  original_filename: string | null;
  mime_type: string;
  size: number;
  is_image: boolean;
  received_at: string;
}

/** Desktop (owner) view of a session. */
export interface PhoneUploadSession {
  id: string;
  status: PhoneUploadSessionStatus;
  expires_at: string;
  max_files: number;
  accept: string;
  files: PhoneUploadFile[];
}

/** Only returned once, when the session is created. */
export interface PhoneUploadSessionCreated extends PhoneUploadSession {
  owner_token: string;
  mobile_url: string;
}

/** Phone view of a session: no file list, no owner token. */
export interface PhoneUploadMobileSession {
  id: string;
  status: PhoneUploadSessionStatus;
  expires_at: string;
  max_files: number;
  accept: string;
  files_received: number;
}
